<template>
  <div class="refund-management">
    <div class="component-container">
      <prepaid-credit :records="addRecords" :orderData="orderData"></prepaid-credit>
      <consumption-amount :records="records" :orderData="orderData"></consumption-amount>
      <!-- <godaddy :records="records" :orderData="orderData"></godaddy> -->
    </div>
  </div>
</template>

<script>
import PrepaidCredit from '@/components/prepaidcredit/prepaidcredit.vue'
import ConsumptionAmount from '@/components/consumption/consumptionAmount.vue'
// import Godaddy from '@/views/refund/godaddy.vue'

export default {
  name: 'RefundManagement',
  components: {
    PrepaidCredit,
    ConsumptionAmount,
    
  },
  props: {
    records: {
      type: Array,
      default: () => []
    },
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 筛选出增加类型的记录
    addRecords() {
      if (!this.records || !this.records.length) return [];
      
      // 根据API返回的数据结构，识别增加类型的记录
      return this.records.filter(record => {
        // 根据截图中的数据结构，判断是否为增加类型记录
        return record.record_type === '增加' || 
               (record.op_money === 100 && record.record_source === 5);
      });
    }
  },
  mounted() {
    console.log('RefundManagement组件挂载完成，records:', this.records);
    console.log('RefundManagement组件挂载完成，records长度:', this.records.length);
    console.log('RefundManagement组件挂载完成，orderData:', this.orderData);
    console.log('筛选的增加类型记录:', this.addRecords);
    
    // 详细检查每条记录
    if (this.records && this.records.length > 0) {
      this.records.forEach((record, index) => {
        console.log(`记录 ${index + 1}:`, record);
        console.log(`记录 ${index + 1} 的 record_type:`, record.record_type);
        console.log(`记录 ${index + 1} 的 op_money:`, record.op_money);
        console.log(`记录 ${index + 1} 的 record_source:`, record.record_source);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.refund-management {
  margin-top: 20px;
  
  .component-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
</style> 